import { render } from "./NoLawyersAcceptedCarousel.vue?vue&type=template&id=7722aab9&scoped=true"
import script from "./NoLawyersAcceptedCarousel.vue?vue&type=script&lang=js"
export * from "./NoLawyersAcceptedCarousel.vue?vue&type=script&lang=js"

import "./NoLawyersAcceptedCarousel.vue?vue&type=style&index=0&id=7722aab9&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7722aab9"]])

export default __exports__